// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/audit.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/audit.tsx");
  import.meta.hot.lastModified = "1732036225893.4856";
}
// REMIX HMR END

import { defer, json, redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { makeDomainFunction } from "domain-functions";
import { z } from "zod";
import { formAction } from "~/components/forms/form-action.server";
import getToken from "~/drupal/auth.server";
import { getClient } from "~/drupal/client.server";
import NodePageComponent from "~/components/node/NodePage";
import { metaTags } from "drupal-remix";
import { Fragment } from "react";
import Navbar from "~/components/navigation/Navbar";
import Footer from "~/components/navigation/Footer";
import { RouteInternalFragment } from "~/drupal/fragments/nodes.server";
import { FooterMenuFragment, MainMenuFragment } from "~/drupal/fragments/menus.server";
import { nodeIsNodePage } from "~/utils/drupalUtils";
import { AuditService } from "~/services/audit.server";
import Heading from "~/components/Heading";
export const meta = ({
  data
}) => {
  const ogImageUrl = data?.reportId && `https://audit.octahedroid.workers.dev/og/${data.reportId}`;
  return metaTags({
    tags: data.node.metatag,
    metaTagOverrides: {
      MetaTagLink: {
        canonical: [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }]
      },
      MetaTagProperty: {
        "og:url": [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }],
        "og:image": ogImageUrl || undefined,
        "og:image:url": ogImageUrl || undefined
      },
      MetaTagValue: {
        "twitter:image": ogImageUrl || undefined
      }
    }
  });
};
export const loader = async ({
  context,
  request
}) => {
  const path = "audit";
  const token = await getToken(context);
  const drupalClient = getClient(token, context);
  const {
    searchParams
  } = new URL(request.url);
  const url = searchParams.get("url");
  const device = searchParams.get("device") || "desktop";
  const reportType = searchParams.get("reportType");
  const reportId = searchParams.get("reportId");
  const {
    route,
    menu
  } = await drupalClient.query({
    route: {
      __args: {
        path: path
      },
      __typename: true,
      on_RouteInternal: {
        ...RouteInternalFragment
      }
    },
    menu: {
      __args: {
        name: "MAIN"
      },
      ...MainMenuFragment
    }
  });
  const {
    menu: footer
  } = await drupalClient.query({
    menu: {
      __args: {
        name: "FOOTER"
      },
      ...FooterMenuFragment
    }
  });
  if (!route || route.__typename !== "RouteInternal" || !route.entity) {
    return redirect("/404");
  }
  const pageData = {
    node: route.entity,
    menu,
    footer,
    environment: context.ENVIRONMENT,
    reportId
  };
  if (url && reportType) {
    const auditResult = AuditService.findAuditByParams({
      reportType,
      url,
      device,
      fullMode: true,
      auditAuthorizationToken: context.AUDIT_AUTHORIZATION_TOKEN
    });
    return defer({
      ...pageData,
      audit: auditResult
    }, {
      status: 200
    });
  }
  return json({
    ...pageData,
    audit: null
  }, {
    status: 200
  });
};
export const schema = z.object({
  url: z.string({
    required_error: "Invalid URL. Try again"
  }).transform(value => {
    return value && !value.startsWith("http") ? `https://${value}` : value;
  }).pipe(z.string().url({
    message: "Invalid URL. Try again"
  }).refine(value => {
    if (!value) {
      return false;
    }
    const url = new URL(value);
    return url.pathname.length > 1 || url.hostname.includes(".");
  }, {
    message: "Invalid URL. Try again"
  })),
  intent: z.enum(["metrics:mobile", "metrics:desktop", "opengraph"])
});
const mutation = makeDomainFunction(schema)(async ({
  intent,
  url
}) => {
  const intentToObject = {
    "metrics:mobile": {
      device: "mobile",
      type: "speed"
    },
    "metrics:desktop": {
      device: "desktop",
      type: "speed"
    },
    opengraph: {
      type: "opengraph"
    }
  };
  const resolvedIntent = intentToObject[intent];
  return {
    url,
    device: "device" in resolvedIntent ? resolvedIntent.device : undefined,
    type: resolvedIntent.type
  };
});
export const action = async ({
  request,
  context: environment
}) => {
  return await formAction({
    request,
    schema: schema,
    mutation,
    environment
  });
};
export default function Index() {
  _s();
  //@ts-expect-error - Loader data is not typed correctly because defer is bug at this Remix version
  const {
    node,
    menu,
    footer,
    environment
  } = useLoaderData();
  if (!node || !nodeIsNodePage(node)) {
    return <Heading tag="h1">Not Found</Heading>;
  }
  return <Fragment>
      <Navbar navigation={menu?.items} />
      <NodePageComponent node={node} environment={environment} />
      <Footer navigation={footer?.items} />
    </Fragment>;
}
_s(Index, "NrfefKOEugNmSGX1yjaWnGavRhw=", false, function () {
  return [useLoaderData];
});
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;